import React from 'react';
import './styles.css';
import Views from "./components/views";

const MenuItemOptions = () => {

  return (<Views/>);
};

export default MenuItemOptions;